import useErrorHandle from "hooks/useErrorHandle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import useTitle from "hooks/useTitle";
import useSpaceliftVcsReposList from "shared/SpaceliftVcsRepo/useSpaceliftVcsReposList";

import SpaceliftVcsReposEmpty from "./Empty";
import SpaceliftVcsReposTable from "./Table";
import SpaceliftVcsReposPageLayout from "./PageLayout";
import SpaceliftVcsReposFiltersLayout from "./FiltersLayout";

const SpaceliftVcsRepos = () => {
  const {
    repos,
    error,
    loadingContent,
    isEmpty,
    searchIsEmpty,
    startCursor,
    endCursor,
    paginationResetKey,
  } = useSpaceliftVcsReposList();

  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Spacelift Repos · ${accountName}`);

  const ErrorContent = useErrorHandle(error);
  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <SpaceliftVcsReposPageLayout pageIsEmpty={isEmpty}>
      <SpaceliftVcsReposFiltersLayout>
        {isEmpty && <SpaceliftVcsReposEmpty />}
        {searchIsEmpty && <SpaceliftVcsReposEmpty hasNoSearchResult />}

        {!isEmpty && !searchIsEmpty && (
          <SpaceliftVcsReposTable
            repos={repos}
            loading={loadingContent}
            startCursor={startCursor}
            endCursor={endCursor}
            resetKey={paginationResetKey}
          />
        )}
      </SpaceliftVcsReposFiltersLayout>
    </SpaceliftVcsReposPageLayout>
  );
};

export default SpaceliftVcsRepos;
